"use strict";

export default {
  namespaced: true,

  state: {
    currentLanguage: null
  },

  mutations: {
    setCurrentLanguage(state, payload) {
      state.currentLanguage = payload;
    }
  },

  actions: {
    changeCurrentLanguage({ commit }, payload) {
      commit("setCurrentLanguage", payload);
    }
  },

  getters: {
    currentLanguage(state) {
      return state.currentLanguage;
    }
  }
};
